"use strict";
import * as BootstrapESM from "bootstrap";
window.bootstrap = BootstrapESM;
export * from "bootstrap";
